import { memo } from 'react'
import { Button } from '@components/v2/button'
import { cn } from '@global/utils/tailwind'

interface StepperProps {
  steps?: string[]
  activeStep: number
  completed?: boolean[]
  disabled?: boolean[]
  isCompleted?: boolean
  className?: string
  onStepClick: (index: number) => void
}

export const Stepper = memo(
  ({
    steps = [],
    completed = [],
    disabled = [],
    activeStep,
    isCompleted,
    className,
    onStepClick,
  }: StepperProps) => (
    <div className={cn('flex items-center gap-2', className)}>
      {steps.map((title, index) => {
        const isDisabled = disabled[index]
        const isActive = index === activeStep || completed[index]

        return (
          <Button
            variant="text"
            key={title}
            className={cn({ 'text-[#8E9EA5]': !isActive, '!bg-[unset]': isDisabled }, 'group')}
            disabled={isDisabled}
            onClick={() => {
              onStepClick(index)
            }}
          >
            <div
              className={cn(
                'size-[24px] flex items-center justify-center rounded-[50%]',
                isDisabled || !isActive ? 'bg-cv-blue-200' : 'bg-cv-primary',
              )}
            >
              <p
                className={cn(
                  'font-semibold text-[13px]',
                  isDisabled || !isActive ? 'text-cv-blue-500' : 'text-white',
                )}
              >
                {(completed[index] && activeStep !== index) || isCompleted ? '✓' : index + 1}
              </p>
            </div>
            <span className="group-hover:underline font-semibold text-[13px]">{title}</span>
          </Button>
        )
      })}
    </div>
  ),
)

Stepper.displayName = 'Stepper'
